
const appRouter = {
  advancedReportPath: ({ id, }) => `/advanced-reports/${id}/edit`,


  bankPath: (bank) => `/banks/${bank.rssd}`,
  bankContactsPath: (bank) => `/banks/${bank.rssd}/contacts`,
  bankListsPath: () => '/banks/lists',
  bankSchedulePath: (props) => {
    // logg(props, 'banksSchedulePath')
    const { bank_rssd, schedule_id = 'ORGPROF' } = props
    return `/banks/${bank_rssd}/schedules/${schedule_id}`
  },
  bankSchedulePlotPath: ({ bank_rssd, schedule_id }) => `/banks/${bank_rssd}/schedules/${schedule_id}/plot`,

  bankSchedulesPath: (bank) => `/banks/${bank.rssd}/schedules`,
  bankSchedulesRoute: "/banks/:rssd/schedules",

  banksPath: () => "/banks",
  banksResultsRoute: '/banks/results',
  banksSearchPath: () => `/banks/search`,

  docsShowPath: ( code = 'ORGPROF' ) => `/data-dictionary/${code}`,

  fintechPath: (fintech) => `/fintechs/${fintech.id}`,
  fintechsPath: () => "/fintechs",

  listPath: (id) => `/lists/${id}`,

  reportPath: ({ id, }) => `/reports/${id}/edit`,

  queryEditPath: ({ id, }) => `/queries/${id}/edit`,
  queryEditRoute: "/queries/:query_id/edit",
  queriesViewPath: ({ selectedQueries, }) => `/queries/view/${Object.keys(selectedQueries).join(',')}`,


}
export default appRouter
